import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl, defineMessages } from 'react-intl';
import { fetchVirtualOperatorUsersRequest } from '../../../../js/virtualOperator/actions';
import {
  getVirtualOperatorUsers,
  getVirtualOperatorUsersTotal,
  virtualOperatorUsersError,
  virtualOperatorUsersLoaded,
} from '../../../../js/virtualOperator/selectors';
import Pagination from '../../../../components/Pagination';
import GlobalErrorPage from '../../../pages/GlobalErrorPage';
import Loading from '../../../../components/Loading';
import HelpButton from '../../../../components/HelpButton';
import PbxVirtualOperatorUserRow from './PbxVirtualOperatorUserRow';
import Filters from '../../../../components/Filters';
import Search from '../../../../components/formControls/Search';
import { fetchPbxQueuesRequest } from '../../../../js/phone/actions';

const PAGE_SIZE = 10;

const messages = defineMessages({
  enabled: {
    id: 'PbxVirtualOperatorUsersList.enabled',
    defaultMessage: 'Enabled',
  },
  user: {
    id: 'PbxVirtualOperatorUsersList.user',
    defaultMessage: 'User',
  },
  extension: {
    id: 'PbxVirtualOperatorUsersList.extension',
    defaultMessage: 'Extension',
  },
  alias: {
    id: 'PbxVirtualOperatorUsersList.alias',
    defaultMessage: 'Alias',
  },
  office: {
    id: 'PbxVirtualOperatorUsersList.office',
    defaultMessage: 'Office',
  },
  pronunciation: {
    id: 'PbxVirtualOperatorUsersList.pronunciation',
    defaultMessage: 'Additional pronunciation',
  },
  transfer: {
    id: 'PbxVirtualOperatorUsersList.transfer',
    defaultMessage: 'Transfer profile',
  },
  searchPlaceHolder: {
    id: 'PbxVirtualOperatorUsersList.searchPlaceHolder',
    defaultMessage: 'Filter users by name or surname',
  },
  noRow: {
    id: 'PbxVirtualOperatorUsersList.noRow',
    defaultMessage: 'There are no user',
  },
});

class PbxVirtualOperatorUsersList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 0,
      name: null,
    };
  }

  componentDidMount() {
    const params = {
      page: 0,
      pageSize: PAGE_SIZE,
      name: null,
    };
    this.props.fetch(params);
    this.props.fetchQueues();
  }

  handleFilter = (name) => {
    this.setState({ name });
    const params = {
      page: 0,
      pageSize: PAGE_SIZE,
      name,
    };
    this.props.fetch(params);
  };

  handlePage = (pageNumber) => {
    this.setState({ currentPage: pageNumber });
    const params = {
      page: pageNumber,
      pageSize: PAGE_SIZE,
      name: this.state.name,
    };
    this.props.fetch(params);
  };

  render() {
    const {
      errorFetch,
      users,
      pages,
      loading,
      intl: { formatMessage },
    } = this.props;
    return (
      <>
        <Filters id={this.props.id}>
          <div className="row pt-2 pb-2">
            <div className="col">
              <Search
                id="filterNameUser"
                name="filterNameUser"
                placeholder={formatMessage(messages.searchPlaceHolder)}
                onChange={this.handleFilter}
                text={this.state.name}
              />
            </div>
          </div>
        </Filters>
        {errorFetch ? (
          <GlobalErrorPage />
        ) : loading ? (
          <Loading />
        ) : (
          <div className="rounded border p-2 mt-2">
            <table className="table table-borderless table-hover">
              <thead
                style={{
                  color: 'var(--yn-blue-darkest)',
                }}
              >
                <tr>
                  <th>{formatMessage(messages.user)}</th>
                  <th>{formatMessage(messages.enabled)}</th>
                  <th>{formatMessage(messages.alias)}</th>
                  <th>{formatMessage(messages.office)}</th>
                  <th>{formatMessage(messages.pronunciation)}</th>
                  <th>{formatMessage(messages.transfer)}</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {users.map((user) => (
                  <PbxVirtualOperatorUserRow key={user} user={user} />
                ))}
              </tbody>
              {(!users || users.length === 0) && (
                <tfoot>
                  <tr>
                    <td colSpan="7">{formatMessage(messages.noRow)}</td>
                  </tr>
                </tfoot>
              )}
            </table>
          </div>
        )}
        {!loading && pages > 1 && (
          <Pagination
            pages={pages}
            currentPage={this.state.currentPage}
            handlePage={this.handlePage}
          />
        )}
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    loading: !virtualOperatorUsersLoaded(state),
    errorFetch: virtualOperatorUsersError(state),
    users: getVirtualOperatorUsers(state),
    pages: Math.ceil(getVirtualOperatorUsersTotal(state) / PAGE_SIZE),
  };
}

export default injectIntl(
  connect(mapStateToProps, {
    fetchQueues: fetchPbxQueuesRequest,
    fetch: fetchVirtualOperatorUsersRequest,
  })(PbxVirtualOperatorUsersList)
);
